import { connect } from 'react-redux';
import { selectShowSmartSpotBanner, selectActiveVenue } from 'selectors/general';
import { updateSmartSpot as updateSmartSpotAction } from 'components/SmartSpot';
import { dismissSmartSpotBanner as dismissSmartSpotBannerAction } from './SmartSpotBanner.saga';
import SmartSpotBanner from './SmartSpotBanner';

const mapStateToProps = state => {
  return {
    venue: selectActiveVenue(state),
    showSmartSpotBanner: selectShowSmartSpotBanner(state),
  };
};

const mapDispatchToProps = {
  updateSmartSpot: updateSmartSpotAction,
  dismissSmartSpotBanner: dismissSmartSpotBannerAction,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const {
    venue: { venueId },
    showSmartSpotBanner,
  } = stateProps;
  const { dismissSmartSpotBanner } = dispatchProps;

  return {
    ...stateProps,
    ...ownProps,
    venueId,
    dismissBanner: dismissSmartSpotBanner.bind(null, { venueId }),
    showSmartSpotBanner,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SmartSpotBanner);
